import { bindable } from 'aurelia-framework';

class ProductSettingsContainer {
  @bindable selectedAccount = null;
  @bindable selectedProduct = null;
  @bindable route = '#';
  loading = false;
  settings = null;
  links = ['product_url', 'base_image'];
  images = ['base_image'];
  /**
   * @param {AppErrorPublisher}    appErrorPublisher    To publish errors to the UI.
   * @param {errorParser}          errorParser          Used for error parsing.
   * @param {ProductFeedsProducts} productFeedsProducts To get a product.
   */
  constructor(appErrorPublisher, errorParser, productFeedsProducts) {
    'inject';

    this._appErrorPublisher = appErrorPublisher;
    /**
     * The parser the container will use to format possible errors.
     * @type {ParserrorWrapper}
     * @access protected
     * @ignore
     */
    this._productSettingsErrorParser = errorParser.wrap();
    this._productFeedsProducts = productFeedsProducts;
  }
  selectedAccountChanged() {
    if (!this.loading && this.selectedProduct) {
      this._loadSettings();
    }
  }
  selectedProductChanged() {
    if (!this.loading && this.selectedAccount) {
      this._loadSettings();
    }
  }
  _loadSettings() {
    this.loading = true;
    this._productFeedsProducts.getProductSettings(
      this.selectedAccount.id,
      this.selectedProduct.id,
    )
    .then((settings) => {
      this.settings = settings;
    })
    .catch((error) => {
      const parsedError = this._productSettingsErrorParser(
        error,
        'There was an error loading the settings',
      );

      this._appErrorPublisher.notify(error, parsedError.message);
    })
    .then(() => {
      this.loading = false;
    });
  }
}

export { ProductSettingsContainer };
